// extracted by mini-css-extract-plugin
export default {"eventList":"EventList_eventList__XgXKr","event":"EventList_event__KZH7p","eventBtn":"EventList_eventBtn__9rtwy","eventBorder":"EventList_eventBorder__z0HOu"};